import ClarityProvider from "./ClarityProvider";

export default ClarityProvider;
